import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { MILLIS_PER_SECOND } from '../../helpers/assets/durationSecondsToMillis';

function VideoProgress(props) {
  const { progress, duration } = props;
  const progressInPercents = (100 * progress * MILLIS_PER_SECOND) / duration;

  return (
    <div className="catalogItem__videoProgress">
      <div
        className="catalogItem__videoProgress-bar"
        style={{ width: `${progressInPercents}%` }}
      />
    </div>
  );
}

VideoProgress.propTypes = {
  duration: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
};

export default memo(VideoProgress);
